/**
 * Build identity.
 *
 * ── WHY THIS EXISTS, AND WHY IT IS ITS OWN FILE ─────────────────────────────
 * The same reason it exists in Kartbord: five deploys in a day with nothing on
 * screen to tell them apart makes "is this the version I just shipped?" an
 * unanswerable question, and every subsequent bug report starts from a guess.
 *
 * `BUILD` is the identity — bumped automatically by `deploy.sh`, so it cannot be
 * forgotten. `BUILD_NOTE` is what changed, written by hand, because a version
 * number alone tells you *that* something moved and never *what*.
 *
 * Kept in a file of its own so the bump is a one-line rewrite that cannot
 * disturb anything around it.
 */
export const BUILD = "0.1.164";
export const BUILD_NOTE =
  "Historical clock, landing ships, stable ZOC and visible operation phases";
